module.exports = __webpack_public_path__ + "img/about-us.6bdfde15.jpg";